import React, { useEffect } from 'react';
import './Toast.css';

const Toast = ({
  message,
  type = 'success',
  show,
  onClose,
  duration = 3000,
  persist = false,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction
}) => {
  useEffect(() => {
    // Only auto-close if show is true, persist is false, and onClose is provided
    if (show && !persist && onClose) {
      const timer = setTimeout(() => {
        try { onClose(); } catch {}
      }, duration);
      return () => clearTimeout(timer);
    }
    // If persist is true, don't set any timer - toast stays until user dismisses
  }, [show, duration, persist, onClose]);

  if (!show) return null;

  const handleBackdropClick = (e) => {
    if (persist && e.target === e.currentTarget) {
      try { onClose && onClose(); } catch {}
    }
  };

  return (
    <>
      {persist && (
        <div
          onClick={handleBackdropClick}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9998,
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            cursor: 'pointer'
          }}
        />
      )}
      <div 
        className={`toast toast-${type}`}
        style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          backgroundColor: type === 'success' ? '#10b981' : (type === 'warning' ? '#f59e0b' : (type === 'error' ? '#ef4444' : '#3b82f6')),
          color: 'white',
          padding: '16px 20px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          minWidth: '300px',
          maxWidth: '500px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}
      >
      <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
        {type === 'success' ? '✓' : type === 'warning' ? '⚠' : type === 'error' ? '✗' : 'ℹ'}
      </span>
      <span style={{ flex: 1, fontSize: '14px', fontWeight: '500' }}>{message}</span>
      {secondaryActionLabel && onSecondaryAction && (
        <button
          onClick={onSecondaryAction}
          style={{
            background: 'rgba(255,255,255,0.15)',
            border: 'none',
            color: 'white',
            fontSize: '14px',
            cursor: 'pointer',
            padding: '8px 10px',
            borderRadius: '6px',
            marginRight: 8
          }}
        >
          {secondaryActionLabel}
        </button>
      )}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          style={{
            background: 'white',
            border: 'none',
            color: '#111827',
            fontSize: '14px',
            cursor: 'pointer',
            padding: '8px 10px',
            borderRadius: '6px'
          }}
        >
          {actionLabel}
        </button>
      )}
      <button 
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          color: 'inherit',
          fontSize: '20px',
          cursor: 'pointer',
          padding: '0',
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '4px'
        }}
      >
        ×
      </button>
    </div>
    </>
  );
};

export default Toast; 